<script setup lang="ts">
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
const nuxtApp = useNuxtApp()
const { nuxt2Context }: any = nuxtApp
const { localePath } = nuxt2Context

// props
const props = defineProps({
    RecordType: {
        type: Number,
        required: true,
    },
})

</script>

<template>
    <div class="border border-solid border-bfh-border rounded w-full text-center py-2 bg-bfh-sub">
        <nuxt-link :to="localePath('market-index-shop-index-ppdshop-index-sale')"
            class="text-bfh-text-accent underline font-bold">
            <fa-icon :icon="['fas', 'exclamation-circle']" size='3x' class="!text-base" />
            {{ $t('ppd.limitedSaleBeltTitle.' + RecordType) }}
        </nuxt-link>
    </div>
</template>
